import React, { Fragment, useContext } from 'react';
import ChatAppContext from '../../../Context/Chat';
import { Image, LI, UL } from '../../../AbstractElements';
import errorImg from '../../../assets/images/search-not-found.png';
import SearchChatList from './SearchChatList';
import CurrentUser from './CurrentUser';

const ChatStatus = () => {
  const { selectedUserr, memberss, currentUserr, chatss, changeChat, createNewChatAsyn } = useContext(ChatAppContext);
  var images = require.context('../../../assets/images', true);
  const dynamicImage = (image) => {
    return images(`./${image}`);
  };
  const changeChatClick = (e, selectedUserId) => {
    const currentUserId = currentUserr.id;
    const currentChat = chatss.find((x) => x.users.includes(currentUserr.id) && x.users.includes(selectedUserId));
    if (currentChat) {
      changeChat(selectedUserId);
    } else {
      createNewChatAsyn(currentUserId, selectedUserId, chatss);
    }
  };
  var activeChat = 0;
  if (selectedUserr != null) activeChat = selectedUserr.id;
  return (
    <Fragment>
      <div className='chat-box'>
        <div className='chat-left-aside'>
          <CurrentUser />
          <div className='people-list' id='people-list'>
            <SearchChatList />
            {memberss && memberss.length > 0 ? (
              <UL className='simple-list custom-scrollbar'>
                {memberss
                  .filter((x) => x.id !== currentUserr.id)
                  .map((item, id) => {
                    return (
                      <LI key={id} className={`clearfix ${activeChat === item.id ? 'active' : ''}`} onClick={(e) => changeChatClick(e, item.id)}>
                        <div className='d-flex'>
                          <Image src={`${dynamicImage(item.thumb)}`} className='rounded-circle user-image' />
                          <div className={`status-circle ${item.online === true ? 'online' : 'offline'}`}></div>
                          <div className='about flex-grow-1'>
                            <div className='name'>{item.name}</div>
                            <div className='status'>{item.status}</div>
                          </div>
                        </div>
                      </LI>
                    );
                  })}
              </UL>
            ) : (
              <Image className='img-fluid m-auto' src={errorImg} />
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default ChatStatus;
